
//--------------profiles-----------------------------------------------------
const 本地开发 = 0, 测试服 = 1;
const profiles = 1;


//----------------clientjs---------------------------------------------------
let clientjs_host0 = "http://10.1.39.128:8080";
let draco_decoderPath0 = "http://10.1.39.128:8080/libs/draco/"
if (profiles == 本地开发) {
    clientjs_host0 = "http://localhost:8080";
    draco_decoderPath0 = "http://10.1.39.128:8080/libs/draco/"
} else if (profiles == 测试服) {
    draco_decoderPath0 = "http://10.1.39.128:8080/libs/draco/"
    //clientjs_host0 = "http://10.1.39.128:8080";
    clientjs_host0 = "http://ic.toone.com.cn";//2-5 nginx外网
}
export const clientjs_host = clientjs_host0;
export const draco_decoderPath = draco_decoderPath0;//draco wasm glb压缩


let modelDir00,//file
    mongoDatabase00, mongoHost00, mongouser00, mongopass00, PropTable00, InfoTable00, StatusTable00,//mongodb
    workQueue00, rabbitmqUrl00;//rabbitmq
//
PropTable00 = "Props";
InfoTable00 = "Info";
StatusTable00 = "Status";
mongoHost00 = "10.1.39.128:27017";
mongouser00 = "admin";
mongopass00 = "123456";
rabbitmqUrl00 = "amqp://toone:123456@10.1.39.128";

let koaBodyOptions00 = {
    multipart: true,
    jsonLimit: "1mb", formLimit: "56kb", textLimit: "56kb",//Limit只对urlencoded有效
    encoding: "utf-8",
    formidable: {
        maxFields: 1000, maxFieldsSize: 20 * 1024 * 1024,
        maxFileSize: 1024 * 1024 * 1024,//最大上传1G文件
        keepExtensions: true, encoding: "utf-8"
    }//上传文件大小限制
};
//
if (profiles == 测试服) {
    modelDir00 = "/data0/ModelStore/";
    mongoDatabase00 = "test";
    workQueue00 = "task";
} else if (profiles == 本地开发) {
    modelDir00 = "H:/data/ModelStore/";
    mongoDatabase00 = "localTest";
    workQueue00 = "localTask";
}
//--------------file--------------
export const modelDir0 = modelDir00;
//--------mongodb---------------------------
export const mongoDatabase0 = mongoDatabase00;
export const mongoHost0 = mongoHost00;
export const mongouser0 = mongouser00;
export const mongopass0 = mongopass00;
//table
export const PropTable0 = PropTable00;
export const InfoTable0 = InfoTable00;
export const StatusTable0 = StatusTable00;
//------------rabbitmq-----------------------
export const rabbitmqUrl0 = rabbitmqUrl00;
export const workQueue0 = workQueue00;
//------------koa-------------------------
export const koaBodyOptions0 = koaBodyOptions00;
